<template>
  <li class="active">
    <div
      ref="title"
      class="point_title"
      :class="sgnInpCompYn ? 'checked on' : expanded ? 'opened on' : ''"
      @click="toggle"
    >
      <p class="tit_point">{{ vo.ctnsKdCdNm }}</p>
    </div>
    <transition
      @enter="onEnter"
      @after-enter="onAfterEnter"
      @before-leave="onBeforeLeave"
      @leave="onLeave"
    >
      <div
        class="vue-accordion"
        ref="wrapper"
        v-show="expanded"
        :style="wrapperStyle"
      >
        <div class="point_contents vue-accordion__inner" ref="inner">
          <slot></slot>
        </div>
      </div>
    </transition>
  </li>
</template>
<script>
import { inject, ref } from "vue";
import { useStore } from "vuex";
import util from "@/common/util";
import { sessionUserInfo } from "@/common/sessionFactory";
import useDialog from "@/common/dialog";
export default {
  name: "Accordion",
  props: {
    idx: {
      type: Number,
      required: true,
    },
    duration: {
      type: Number,
      default: 500,
    },
    vo: {
      type: Object,
      default: {},
    },
    pdIntAgr: {
      type: Object,
      default: {},
    },
  },

  setup(props, { slots, emit }) {
    const store = useStore();

    let slotList = slots.default();
    let isSlotEmpty = _.every(slotList, (data) => {
      if (
        typeof data.children == "string" &&
        (data.children == "v-if" || data.children == "")
      ) {
        return true;
      } else if (_.isArray(data.children)) {
        return _.every(data.children, (e) => {
          return e.children == "v-if" || e.children == "";
        });
      }
    });

    const axios = inject("axios");
    const dialog = useDialog(inject("$vfm"));

    const expanded = ref(null);
    expanded.value = false;

    const sgnInpCompYn = ref(false);

    const opmtCrtYn = ref(false);
    const sgnBeinOpmtCtnsKdList =
      "100304,113356,100740,100738,000511,000505,112636,119698,116314,116007,120638,123762";

    const docCnf = () => {
      if (sgnInpCompYn.value) {
        showOpmtDialog();
      } else if (!expanded.value) {
        toggle();
      } else if (
        expanded.value &&
        (props.vo.ctnsKdCd == "100740" || props.vo.ctnsKdCd == "100741")
      ) {
        createNwOpmtJpg().then(showOpmtDialog);
      } else if (expanded.value) {
        if (!opmtCrtYn.value) {
          createNwOpmtJpg().then(showOpmtDialog);
        } else {
          showOpmtDialog();
        }
      }
    };

    const toggle = () => {
      if (!isSlotEmpty) expanded.value = !expanded.value;
      // 상품소개 동의서는 열린 후 서류확인 시 생성하게끔 변경
      if (props.vo.ctnsKdCd == "100740" || props.vo.ctnsKdCd == "100741") {
        emit("openDoc");
        return;
      }
      // 서명이 들어간 출력물일 경우
      if (
        sgnBeinOpmtCtnsKdList.indexOf(props.vo.ctnsKdCd) != -1 &&
        !opmtCrtYn.value
      ) {
        createNwOpmtJpg().then(() => {
          if (isSlotEmpty) showOpmtDialog();
        });
      } else if (sgnBeinOpmtCtnsKdList.indexOf(props.vo.ctnsKdCd) == -1) {
        if (isSlotEmpty) showOpmtDialog();
      } else {
        if (isSlotEmpty) showOpmtDialog();
      }
      emit("openDoc");
    };

    function showOpmtDialog() {
      dialog
        .lyorPop(
          "common/dialog/OpmtViewPop.vue",
          { data: props.vo.data },
          { content: "full" }
        )
        .then((res) => {
          if (props.vo.ctnsKdCd == "000352") {
            sgnInpCompYn.value = true;
            expanded.value = false;
          } else if (!_.isNull(res) && !_.isEmpty(res)) {
            if (res == "success") {
              sgnInpCompYn.value = true;
              expanded.value = false;
            }
          }
          emit("sgnSucceed");
        });
    }

    async function createNwOpmtJpg() {
      let param = _.cloneDeep(sessionUserInfo);

      let opmtCtnsKdCdList = _.groupBy(props.vo.data, "ctnsKdCd");

      param.opmtCtnsKdCd = "";

      if (props.vo.ctnsKdCd == "100304") {
        _.each(opmtCtnsKdCdList, (v) => {
          if (v[0].ctnsKdCd == "100304" || v[0].ctnsKdCd == "113356")
            param.opmtCtnsKdCd += v[0].ctnsKdCd + "|";
        });
        param.opmtCtnsKdCd = param.opmtCtnsKdCd.substring(
          0,
          param.opmtCtnsKdCd.length - 1
        );
      } else {
        param.opmtCtnsKdCd = props.vo.data[0].ctnsKdCd;
      }

      param.currentDate = util.formatDate(new Date(), "yyyymmdd");

      param.agrInf = {
        advtLnmInfRciAgrYn: props.pdIntAgr.advtLnmInfRciAgrYn,
        indvInfInqAgrYn: props.pdIntAgr.indvInfInqAgrYn,
        indvInfUseAgrYn: props.pdIntAgr.indvInfUseAgrYn,
        ctrCcluAgrYn: "",
        elcSgnAgrYn: "",
        papeAgrYn: "",
        pdIntAgrYn: "",
      };

      let ctrBasInfCoVo = sessionUserInfo.ctrBasInfCoVo[0];

      param.sbcpDt = ctrBasInfCoVo.sbcpDt;
      param.cusNm = ctrBasInfCoVo.polhdNm;

      if (ctrBasInfCoVo.agplrCd == "") {
        param.trtpeOrgNm = ctrBasInfCoVo.trtpeOrgNm;
      } else {
        param.trtpeOrgNm = ctrBasInfCoVo.agplrNm;
      }

      let polhdRelLst = sessionUserInfo.polhdRelLst;

      if (sessionUserInfo.pidfPdYn) {
        if (sessionUserInfo.inspeCnt >= 1) {
          try {
            param.agrInf.inspeNm = polhdRelLst[0].cusNm;
          } catch (Ex) {
            param.agrInf.inspeNm = "";
          }
        }

        if (sessionUserInfo.inspeCnt >= 2) {
          try {
            param.agrInf.inspeNm1 = polhdRelLst[1].cusNm;
          } catch (Ex) {
            param.agrInf.inspeNm1 = "";
          }
        }
        if (sessionUserInfo.inspeCnt >= 3) {
          try {
            param.agrInf.inspeNm2 = polhdRelLst[2].cusNm;
          } catch (Ex) {
            param.agrInf.inspeNm2 = "";
          }
        }
        if (sessionUserInfo.inspeCnt >= 4) {
          try {
            param.agrInf.inspeNm3 = polhdRelLst[3].cusNm;
          } catch (Ex) {
            param.agrInf.inspeNm3 = "";
          }
        }
      }

      if (
        sessionUserInfo.pidfPdYn &&
        ((sessionUserInfo.piSmns == "2" && sessionUserInfo.inspeCnt > 1) ||
          (sessionUserInfo.piSmns == "1" && sessionUserInfo.inspeCnt >= 1))
      ) {
        param.agrInf.papeAgrYn = "1";
      }

      param = _.merge(param, store.state.elcSgnInf.acntInf);
      param = _.merge(param, store.state.elcSgnInf.cfntInf);

      param.dporBdt = sessionUserInfo.dporCd?.substr(0, 6) ?? "";
      if (param.rlhrAcntAttrYn == "2") {
        param.bankNm = "";
        param.acntNo = "";
      }

      let preloadImages = [];

      //출력물 조회용 계약자 발송요청ID 셋팅
      param.dataId = sessionUserInfo.mblPrtKey;

      let inspeTrgCoVo = _.filter(
        store.state.elcSgnInf.elcSgnTrgCoVo,
        (data) => data.ptyRlCd.indexOf("02") >= 0
      )[0];

      //예금주 당사자 존재여부 확인
      if (inspeTrgCoVo.ptyRlCd.indexOf("71") >= 0) {
        param.dporElcSgnYn = "Y";
      } else {
        param.dporElcSgnYn = "N";
      }
      // 발행자정보조회
      var pblerParam = {
        prctrNo: sessionUserInfo.prctrNo,
        orgId: sessionUserInfo.orgId,
        orgCd: sessionUserInfo.orgCd,
      };
      await axios.json("/getOpmtInq.do", pblerParam).then(function (result) {
        param.pblerNm = result.data.pblerNm;
      });
      await axios.json("/inspe/createInspeOpmt.do", param).then((result) => {
        let opmtData = _.sortBy(result.data.row, (row) => {
          return row.seq;
        });

        let pages = result.data.pageNums.split(",");

        let pageIdx = 0;

        //첫 서명 대상 페이지
        let pageNum = Number(pages[pageIdx]);

        let imageInfo_119467 = {};

        let imageListFilter = _.filter(param.imageList, function (info) {
          return info.ctnsKdCd == "119467";
        });

        if (opmtData.length >= 1) {
          if (opmtData[0].ctnsKdCd == "100304") {
            opmtData[pageNum - 1].isSign = "Y";
          }

          //청약서 표지 있을경우 서명입력 페이지 동기화
          if (imageListFilter.length > 0 && opmtData[0].ctnsKdCd == "100304") {
            imageInfo_119467.atcFileNm = imageListFilter[0].atcFileNm;
            imageInfo_119467.ctnsKdCd = imageListFilter[0].ctnsKdCd;
            imageInfo_119467.otptYn = "2";
            imageInfo_119467.sDisplayName = "청약서";
            imageInfo_119467.imageData = imageListFilter[0].imageData;
            opmtData.unshift(imageInfo_119467);
            _.each(pages, (d, i) => {
              pages[i] = Number(d) + 1;
            });
            pageNum = Number(pages[pageIdx]);
          }
        }

        util.fillDocCode(opmtData, param.opmtCtnsKdCd);

        store.commit("elcSgnInf/pushImageData", opmtData);
        opmtCrtYn.value = true;

        props.vo.data = _.map(props.vo.data, (d, e) => {
          if (pages.length > 1) {
            if (pageNum == e + 1) {
              d.signImageData =
                opmtData[e].imageData + "&" + new Date().getTime();
              d.isSignRequired = true;
              console.log("r" + d.isSignRequired);
              d.isSigned = false;
              preloadImages.push(d.imageData);
              preloadImages.push(d.signImageData);
              pageIdx++;
              pageNum = Number(pages[pageIdx]);
            }
          } else if (Number(pageNum) == e + 1) {
            d.signImageData =
              opmtData[e].imageData + "&" + new Date().getTime();
            d.isSignRequired = true;
            console.log("k" + d.isSignRequired);
            d.isSigned = false;
            preloadImages.push(d.imageData);
            preloadImages.push(d.signImageData);
          } else if (
            d.ctnsKdCd == "100738" ||
            d.ctnsKdCd == "100739" ||
            d.ctnsKdCd == "100740" ||
            d.ctnsKdCd == "100741" ||
            d.ctnsKdCd == "100735" ||
            d.ctnsKdCd == "120638"
          ) {
            d.isAgr = true;
            d.agrImageData = opmtData[e].imageData + "&" + new Date().getTime();
            preloadImages.push(d.agrImageData);
          } else {
            preloadImages.push(d.imageData);
          }
          console.log("s" + d.isSignRequired);
          return d;
        });

        emit("docCreated");
      });

      var images = [];
      function preload(imgList) {
        let promises = [];
        _.each(imgList, (d, i) => {
          images[i] = new Image();
          images[i].src = d;

          promises.push(
            new Promise((resolve, reject) => {
              images[i].onload = function (res) {
                resolve(res);
              };
            })
          );
        });
        return Promise.all(promises);
      }

      //-- usage --//
      preload(preloadImages);
    }

    const clearSgnInpCompYn = () => {
      sgnInpCompYn.value = false;
      expanded.value = true;
      _.each(props.vo.data, (d) => {
        if (d.isAgr) {
          d.agrImageData += "&";
        }
      });
    };

    return {
      docCnf,
      toggle,
      sgnInpCompYn,
      expanded,
      clearSgnInpCompYn,
      opmtCrtYn,
    };
  },

  computed: {
    wrapperStyle() {
      return {
        transitionDuration: `${this.duration}ms`,
      };
    },
  },
  mounted() {
    if (this.expanded) {
      this.setWrapperHeightTo("auto");
    }
  },
  methods: {
    onEnter(el) {
      this.setWrapperHeightTo(this.getContentHeight(this.$refs.inner), el);
    },
    onAfterEnter(el) {
      this.setWrapperHeightTo("auto", el);
      window.scrollBy({
        top: el.getBoundingClientRect().top - 60,
        behavior: "smooth",
      });
      if (this.opmtCrtYn) {
        this.$emit("docCreated");
      }
    },
    onBeforeLeave(el) {
      this.setWrapperHeightTo(this.getContentHeight(el), el);
    },
    onLeave(el) {
      // el.scrollHeight
      this.setWrapperHeightTo(0, el);
      window.scrollBy({
        top: this.$refs.title.getBoundingClientRect().top - 60,
      });
    },
    getContentHeight(el) {
      // const inner = this.$refs.inner
      return el.getBoundingClientRect().height;
    },
    /**
     * @param {number | 'auto'} height
     */
    setWrapperHeightTo(height, el = this.$refs.wrapper) {
      el.style.height = typeof height === "number" ? `${height}px` : height;
    },
  },
};
</script>

<style scoped>
.vue-accordion {
  transition-timing-function: ease;
  transition-property: height;
  height: 0;
  overflow: hidden;
}
.vue-accordion__inner {
  display: table;
  width: 100%;
}
/* .vue-accordion
  transition-timing-function ease
  transition-property height
  height 0
  overflow hidden
.vue-accordion__inner {
    display: "table"
    width 100%
} */
</style>
